var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitDoor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 270",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 287,
    width: 287,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#ffffff",
    ry: 130,
    rx: 130,
    id: "svg_30",
    cy: 141.25,
    cx: 142.5,
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5102041059610798,0,0,0.5102041059610798,0,0) ",
    id: "svg_26"
  }, /*#__PURE__*/React.createElement("title", {
    transform: "translate(-71.04999542236328,-73.5) translate(0,9.799999237060547) translate(110.24999237060547,97.99999237060547) translate(-534.0999755859375,-342.9999694824219) translate(-12.249999046325684,-2.4499998092651367) translate(644,0) translate(0,462.9999694824219) "
  }, "background"), /*#__PURE__*/React.createElement("rect", {
    x: 135.85002,
    y: 150.84999,
    width: 282,
    height: 252,
    id: "svg_24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_23",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_27",
    width: 800,
    height: 600,
    x: 136.85002,
    y: 151.84999,
    strokeWidth: 0,
    fill: "url(#gridpattern)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5102041059610798,0,0,0.5102041059610798,0,0) ",
    id: "svg_28"
  }, /*#__PURE__*/React.createElement("title", {
    transform: "translate(-71.04999542236328,-73.5) translate(0,9.799999237060547) translate(110.24999237060547,97.99999237060547) translate(-534.0999755859375,-342.9999694824219) translate(-12.249999046325684,-2.4499998092651367) translate(644,0) translate(0,462.9999694824219) "
  }, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeWidth: 0,
    x: 226.47505,
    y: 163.33967,
    width: 166.83334,
    height: 228,
    id: "svg_22",
    stroke: "#000",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 153.633,
    y: 273.66249,
    width: 147.36842,
    height: 7.89474,
    id: "svg_21",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeWidth: 15,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 146.10564,
    y: 244.75212,
    width: 67.10584,
    height: 7.89474,
    id: "svg_20",
    rx: 1,
    transform: "rotate(130 179.6585540771484,248.69949340820318) ",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeWidth: 15,
    x: 146.10564,
    y: 244.75212,
    width: 67.10584,
    height: 7.89474,
    id: "svg_19",
    rx: 1,
    transform: "rotate(130 179.6585693359375,248.69943237304693) ",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeWidth: 15,
    fillOpacity: "null",
    x: 145.51308,
    y: 299.12221,
    width: 63.05659,
    height: 7.89474,
    id: "svg_18",
    rx: 1,
    transform: "rotate(50 177.04138183593747,303.0695495605469) ",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15,
    fillOpacity: "null",
    x: 153.633,
    y: 273.66249,
    width: 147.36842,
    height: 7.89474,
    id: "svg_17",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#edb6dc",
    strokeWidth: 15,
    x: 235.86984,
    y: 273.66249,
    width: 65.13158,
    height: 7.89474,
    id: "svg_16",
    rx: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#edb6dc",
    strokeWidth: 15,
    x: 235.86984,
    y: 273.66249,
    width: 65.13158,
    height: 7.89474,
    id: "svg_15",
    rx: 1,
    stroke: "#e91f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFAC8D",
    strokeWidth: 15,
    x: 233.89615,
    y: 273.66249,
    width: 59.86843,
    height: 7.89474,
    id: "svg_14",
    stroke: "#e91f3e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitDoor);
export default __webpack_public_path__ + "static/media/Exit_door.88c066b9f8e494ac5edd0a8f96f45f71.svg";
export { ForwardRef as ReactComponent };